(function() {
  'use strict';

  var AnnouncementBar = (function() {
    var observer = null;
    var rafId = null;

    function init() {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;

      var section = bar.closest('.shopify-section');
      if (!section) return;

      section.classList.add('announcement-bar-sticky');

      function update() {
        var height = section.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--announcement-height', Math.round(height) + 'px');
      }

      if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(function() {
          if (rafId) return;
          rafId = requestAnimationFrame(function() {
            rafId = null;
            update();
          });
        });
        observer.observe(section);
      } else {
        update();
        window.addEventListener('resize', onResize);
      }

      update();
    }

    function onResize() {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;

      var section = bar.closest('.shopify-section');
      if (!section) return;

      var height = section.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--announcement-height', Math.round(height) + 'px');
    }

    function destroy() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      window.removeEventListener('resize', onResize);

      document.documentElement.style.removeProperty('--announcement-height');
    }

    return { init: init, destroy: destroy };
  })();

  // 订阅恢复 Shopify 原生提交：不能在网络或 CAPTCHA 失败时伪造成功。
  function initAnnouncementBar() {
    AnnouncementBar.destroy();
    AnnouncementBar.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAnnouncementBar();
    });
  } else {
    initAnnouncementBar();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail && e.detail.sectionId) {
      var section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (section && section.querySelector('.announcement-bar')) {
        initAnnouncementBar();
      }
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    if (e.detail && e.detail.sectionId) {
      var section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
      if (section && section.querySelector('.announcement-bar')) {
        AnnouncementBar.destroy();
      }
    }
  });
})();
